/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
import CryptoJS from 'crypto-js';
import Axios from 'axios';

const timestampToTime = timestamp => {
  let date = new Date(timestamp); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-';
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
  let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  return Y + M + D + h + m + s;
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
  let date = new Date();
  date.setDate(date.getDate() + day);
  document.cookie = name + '=' + value + ';expires=' + date;
}

/**
 * 获取cookie
 **/
function getCookie(name) {
  let reg = RegExp(name + '=([^;]+)');
  let arr = document.cookie.match(reg);
  if (arr) {
    return arr[1];
  } else {
    return '';
  }
}

/**
 * 删除cookie
 **/
function delCookie(name) {
  setCookie(name, null, -1);
}

/**
 * 处理接口传参为空删除
 **/
function deleteEmpty(data) {
  for (let key in data) {
    if (data[key] == '') {
      delete data[key];
    }
  }
  return data;
}

/**
 *加密处理
 */
function encryption(params) {
  let { data, type, param, key } = params;
  const result = JSON.parse(JSON.stringify(data));
  if (type === 'Base64') {
    param.forEach(ele => {
      result[ele] = btoa(result[ele]);
    });
  } else {
    param.forEach(ele => {
      var data = result[ele];
      key = CryptoJS.enc.Latin1.parse(key);
      var iv = key;
      // 加密
      var encrypted = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CFB,
        padding: CryptoJS.pad.NoPadding
      });
      result[ele] = encrypted.toString();
    });
  }
  return result;
}
/**
 *接口加密处理
 */
function postEncryption(params) {
  let { data, key } = params;
  key = CryptoJS.enc.Utf8.parse(key);
  data = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
  // 设置加密选项
  var options = {
    mode: CryptoJS.mode.CFB, // CFB 模式
    padding: CryptoJS.pad.NoPadding, // 无填充模式
    iv: key
  };
  const result = CryptoJS.AES.encrypt(data, key, options).toString();
  return result; //  加密出来为 hex格式密文
}
/**
 *接口解密处理
 */
function postDecode(params) {
  let { data, key } = params;
  key = CryptoJS.enc.Utf8.parse(key);
  // 设置加密选项
  var options = {
    mode: CryptoJS.mode.CFB, // CFB 模式
    padding: CryptoJS.pad.NoPadding, // 无填充模式
    iv: key
  };
  const result = CryptoJS.AES.decrypt(data, key, options);
  return JSON.parse(result.toString(CryptoJS.enc.Utf8)); //  加密出来为 hex格式密文
}

function storeLoading(self, sts, info) {
  self.$store.commit('overAllLoadingChange', {
    status: sts,
    info: info || '正在导出中...'
  });
}

/**
 *下载文件流
 */
function downloadFile(fileName, portUrl, data, self, info) {
  // 下载文件名称  文件接口地址 需要传的参数
  let url;
  if (process.env.NODE_ENV === 'development') {
    url = '/est';
  } else {
    url = '';
  }
  storeLoading(self, true, info);
  Axios({
    url: url + portUrl, //请求路径 /subsidiesApply/exportLivestockRecords
    responseType: 'blob', //表明返回服务器返回的数据类型
    method: 'post', //请求方式
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    data: data //请求需要传的参数
  })
    .then(res => {
      if (res.data.success === undefined && res.data.type === 'application/json') {
        const fileReader = new FileReader();
        fileReader.readAsText(res.data, 'utf-8');
        fileReader.onload = function () {
          const result = JSON.parse(fileReader.result);
          self.$message({
            type: 'error',
            message: result.msg || '导出失败'
          });
        };
        storeLoading(self, false, info);
        return false;
      }
      let suffixName = '';
      if (res.headers['content-disposition'] && res.headers['content-disposition'].indexOf('.xlsx') > -1) suffixName = '.xlsx';
      //创建一个隐藏的a链接
      storeLoading(self, false, info);
      const link = document.createElement('a');
      let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' }); //文件流处理
      link.style.display = 'none'; //去除a标签的样式
      // 设置连接
      link.href = URL.createObjectURL(blob);
      link.download = suffixName ? fileName + suffixName : fileName;
      console.log('link 地址', link);
      document.body.appendChild(link);
      //模拟点击事件
      link.click();
      //移除创建的a标签
      window.URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
      self.$message({
        type: 'success',
        message: '导出' + fileName + '成功!'
      });
    })
    .catch(err => {
      storeLoading(self, false, info);
      self.$message({
        type: 'error',
        message: '导出' + fileName + '失败!'
      });
    });
}

/**
 *下载图片
 */
function downloadImg(name, url, that) {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const img = new Image();
  img.crossOrigin = 'Anonymous';
  img.onload = () => {
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0);
    canvas.toBlob(blob => {
      saveAs(blob, name); // 可以自定义你想要的图片名称和格式
    });
  };
  img.src = url;
  setTimeout(() => {
    that.$message(
      {
        type: 'success',
        message: '下载成功'
      },
      1000
    );
  });
}

/**
 * 导出
 **/
export {
  timestampToTime,
  setStore,
  getStore,
  removeStore,
  setCookie,
  getCookie,
  delCookie,
  deleteEmpty,
  encryption,
  postEncryption,
  postDecode,
  downloadFile,
  downloadImg
};



// WEBPACK FOOTER //
// ./src/utils/util.js